// src/contexts/CookiesContext.jsx
import React, { createContext, useState, useContext, useEffect } from 'react';

const CookiesContext = createContext();

export function useCookies() {
  return useContext(CookiesContext);
}

export function CookiesProvider({ children }) {
  const [showBanner, setShowBanner] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user has already made a choice
    const cookiesAccepted = localStorage.getItem('cookies_accepted');
    
    // Check if cookie preferences exist
    const cookiePrefs = localStorage.getItem('cookie_preferences');
    
    if (!cookiesAccepted && !cookiePrefs) {
      // Show banner if no preference has been set
      setShowBanner(true);
    } else {
      setShowBanner(false);
    }
    setLoading(false);
  }, []);

  const acceptAll = () => {
    localStorage.setItem('cookies_accepted', 'all');
    localStorage.setItem('cookie_preferences', JSON.stringify({
      necessary: true,
      analytics: true,
      marketing: true,
      preferences: true
    }));
    setShowBanner(false);
    
    // You can add analytics initialization here
    console.log('All cookies accepted');
  };

  const rejectAll = () => {
    localStorage.setItem('cookies_accepted', 'none');
    localStorage.setItem('cookie_preferences', JSON.stringify({
      necessary: true,
      analytics: false,
      marketing: false,
      preferences: false
    }));
    setShowBanner(false);
    
    // Disable non-essential cookies/tracking here
    console.log('Only essential cookies accepted');
  };

  const acceptCustom = (preferences) => {
    localStorage.setItem('cookies_accepted', 'custom');
    localStorage.setItem('cookie_preferences', JSON.stringify(preferences));
    setShowBanner(false);
    
    // Apply custom cookie preferences here
    console.log('Custom preferences saved:', preferences);
  };

  const value = {
    showBanner,
    loading,
    acceptAll,
    rejectAll,
    acceptCustom,
  };

  return (
    <CookiesContext.Provider value={value}>
      {children}
    </CookiesContext.Provider>
  );
}